let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iDB1L")).then(() => parcelRequire('lM0k7'));